import SavedMarketStateFilterFilter from '@app/model/market_state/_saved_filters/SavedMarketStateFilterFilter';
import { ReportScope, ReportType } from '@app/model/market_state/_export/MarketStateExportReport';

export enum ParityExportReportPeriod {
	CURRENT_MONTH = 'CURRENT_MONTH',
	MONTHS_3 = 'MONTHS_3',
	MONTHS_6 = 'MONTHS_6',
	MONTHS_12 = 'MONTHS_12',
}

type ParityExportReport = {
	id: number
	companyHotelId: number
	name: string
	creationDate: string
	reportType: ReportType
	scope: ReportScope
	period: ParityExportReportPeriod
	fromDate: string | null
	toDate: string | null
	filter: SavedMarketStateFilterFilter
}

export default ParityExportReport;
